import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fields"
}
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_ctx.exif)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            key: field.field
          }, [
            _createElementVNode("label", {
              for: `exif-field-${field.field}`
            }, _toDisplayString(_ctx.label(field)), 9, _hoisted_2),
            _createVNode(_component_NcTextField, {
              class: "field",
              id: `exif-field-${field.field}`,
              disabled: _ctx.disabled,
              "label-outside": true,
              modelValue: _ctx.exif[field.field],
              "onUpdate:modelValue": ($event: any) => ((_ctx.exif[field.field]) = $event),
              placeholder: _ctx.placeholder(field),
              onInput: ($event: any) => (_ctx.dirty[field.field] = true),
              "trailing-button-icon": "close",
              "show-trailing-button": _ctx.dirty[field.field],
              onTrailingButtonClick: ($event: any) => (_ctx.reset(field)),
              onKeypress: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
            }, null, 8, ["id", "disabled", "modelValue", "onUpdate:modelValue", "placeholder", "onInput", "show-trailing-button", "onTrailingButtonClick"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}